/* v8 ignore start */
import { configureStore, Action, ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { ThunkAction } from 'redux-thunk'

import reducer, { RootState } from 'slices'

export const setupStore = (preloadedState?: RootState) => {
    return configureStore({
        reducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
    })
}

export const rootStore = setupStore()
// export const rootStore = configureStore({
//     reducer,
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
// })

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
export type AppDispatch = typeof rootStore.dispatch
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;

export const useAppDispatch: () => ThunkAppDispatch = useDispatch
